import { render, staticRenderFns } from "./ItemsCarousel.vue?vue&type=template&id=1f390ac2&"
import script from "./ItemsCarousel.vue?vue&type=script&lang=js&"
export * from "./ItemsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports